module.exports = __webpack_public_path__ + "static/media/baga.73a589a1.mp3";